/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetReportHeaderQueryResult } from '../../models/get-report-header-query-result';

export interface ApiProjectDailyTaskReportsGetReportHeaderGet$Params {
  ProjectId?: string;
}

export function apiProjectDailyTaskReportsGetReportHeaderGet(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsGetReportHeaderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReportHeaderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsGetReportHeaderGet.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetReportHeaderQueryResult>;
    })
  );
}

apiProjectDailyTaskReportsGetReportHeaderGet.PATH = '/api/ProjectDailyTaskReports/GetReportHeader';
